import $ from "jquery";
import Cookies from "js-cookie";
import { openModal, closeModal } from "../components/modal";

const $document = $(document);
const $signpostModal = $("#signpost-modal");

const cookie_welcome = Cookies.get("cookie_welcome");
if (cookie_welcome === undefined && $signpostModal.length) {
  openModal($signpostModal);
}

$document.on("click", ".signpost-modal__link", () => {
  if (Cookies.get("cookie_welcome") === undefined && $signpostModal.length) {
    Cookies.set("cookie_welcome", "1", { expires: 1 });
    closeModal($signpostModal);
  }
});
